// Generated by Melange

import * as Buhta_cabinet__Link from "../html/Link.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function AdminDashboardHeader(Props) {
  let className = Props.className;
  let title = Props.title;
  let route = Props.route;
  let rightChildrenOpt = Props.rightChildren;
  let arrowBackOpt = Props.arrowBack;
  const rightChildren = rightChildrenOpt !== undefined ? Caml_option.valFromOption(rightChildrenOpt) : null;
  const arrowBack = arrowBackOpt !== undefined ? arrowBackOpt : false;
  return JsxRuntime.jsxs("div", {
    children: [
      route !== undefined ? (
          arrowBack ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                  route: route,
                  children: JsxRuntime.jsx("img", {
                    className: "mr-1",
                    src: StaticAsset.src("/static/icons/arrow-back.svg")
                  })
                }),
                JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                  children: title
                })
              ],
              className: "flex items-center gap-1"
            }) : JsxRuntime.jsx(Buhta_components__Text.H3.make, {
              children: title
            })
        ) : JsxRuntime.jsx(Buhta_components__Text.H3.make, {
          children: title
        }),
      rightChildren
    ],
    className: Cn.fromList({
      hd: "z-90 flex justify-between items-center border-gray-main border-b h-14 px-6",
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    })
  });
}

const make = AdminDashboardHeader;

export {
  make,
}
/* Buhta_cabinet__Link Not a pure module */
